import Component from '@averyano/core/src/classes/Component';

import GSAP from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
GSAP.registerPlugin(ScrollTrigger);

import each from 'lodash/each';

export default class AboutSection extends Component {
	constructor() {
		super({
			element: '.about',
			elements: {
				cover: '.cover',
			},
		});
	}

	create() {
		super.createComponent();

		this.createTimeline();
	}

	createTimeline() {
		if (window.isMobile) return;
		

	}

	clearTimeline() {

	}

	destroy() {
		super.destroy();
		this.clearTimeline();
	}
}
